/**
 * Constantes e catálogos estáticos da Área QPreço.
 *
 * Extraídos de `pages/AreaQprecoIndex.vue` com os mesmos nomes usados nos
 * templates, para manter os bindings idênticos.
 */

export const ADMIN_FEE_PERCENTAGE = 10;
export const MINIMUM_ADMIN_FEE = 250;
export const PAGE_SIZE = 25;

export const SHARE_EXPIRATION_OPTIONS = [
  { value: '7', label: '7 dias' },
  { value: '30', label: '30 dias' },
  { value: '90', label: '90 dias' },
];

export const PRICE_LIMITS = {
  aluguel: { min: 500, max: 15000 },
  temporada: { min: 500, max: 15000 },
  venda: { min: 200000, max: 20000000 },
};

export const detailTabs = [
  {
    value: 'estimativa',
    label: 'Estimativa',
    helper: 'Preço sugerido',
    icon: 'i-lucide-gauge',
  },
  {
    value: 'detalhado',
    label: 'Detalhado',
    helper: 'Histórico e valores',
    icon: 'i-lucide-list-checks',
  },
  {
    value: 'similares',
    label: 'Similares',
    helper: 'Compare com a média',
    icon: 'i-lucide-building-2',
  },
  {
    value: 'condominio',
    label: 'Condomínio',
    helper: 'Negociações do prédio',
    icon: 'i-lucide-landmark',
  },
  {
    value: 'cma',
    label: 'CMA',
    helper: 'Revisão e backtest',
    icon: 'i-lucide-chart-no-axes-combined',
  },
  {
    value: 'diligencia',
    label: 'Diligência',
    helper: 'Registro e evidências',
    icon: 'i-lucide-shield-check',
  },
];

export const sourceOptions = [
  {
    value: 'external',
    label: 'Base integrada',
    icon: 'i-lucide-database',
  },
  { value: 'local', label: 'Carteira interna', icon: 'i-lucide-home' },
];

export const purposeOptions = [
  { value: '', label: 'Todas' },
  { value: 'venda', label: 'Venda' },
  { value: 'aluguel', label: 'Aluguel' },
  { value: 'temporada', label: 'Temporada' },
];

export const benefitItems = [
  {
    title: 'Estimativas de preço',
    body: 'Acompanhe o valor estimado dos seus imóveis em tempo real.',
  },
  {
    title: 'Comparação com similares',
    body: 'Cruzamos seus imóveis com unidades parecidas vendidas e alugadas na região.',
  },
  {
    title: 'Negociações no seu condomínio',
    body: 'Veja o que rolou recentemente no mesmo empreendimento, com confidencialidade.',
  },
];
